import $ from 'jquery'

export default function(o){

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      background: 'url(asset/omb-logo-screen.png)',
      backgroundSize: 'cover',
      width: '400px',
      height: '300px',
      top: 0,
      left: 0,
    })

  return div

}


// WEBPACK FOOTER //
// ./src/client/view/admin/player/background/background.js